export default function Loading() {
    return (
            <>
                <div className="loading">
                    <h1 className="loading-item">Loading....</h1>
                </div>
            </>
    )
}